module.exports = __webpack_public_path__ + "static/media/why_us.f54c7328.png";